import { debounce } from 'lodash';
import { snapshot } from 'valtio';
import { createSimpleAsyncAction } from 'async-utils';
import sbomService from '../services';
import SbomFiltersStore from '../stores/sbom-filters-store';
import { setTotalSbomFilters } from '../stores/sbom-filters-store-actions';
import SbomStore from '../stores/sbom-store';
import {
  setSbomLibraries,
  setSbomLibrariesTotal,
  setSbomOffset,
  setSearchValue,
} from '../stores/sbom-store-actions';
import { loadFilters } from './sbom-libraries-filters-actions';
import { SbomLibraryItem } from '../sbom-types';
import { Nullable } from 'common-types';

export type LoadSbomLibraries = {
  update?: boolean;
  cache?: boolean;
};

export const loadSbomLibraries = createSimpleAsyncAction(
  async (params?: LoadSbomLibraries) => {
    const { update = false } = params || {};

    if (update) SbomStore.offset = 0;

    const { total, offset, searchValue } = snapshot(SbomStore);

    if (total < offset) return;

    const response = await sbomService.getSbomLibraries.execute({
      offset: offset,
      filters: SbomFiltersStore.filterBy,
      search: searchValue,
      limit: 100,
    });

    if (response && response.sbomLibs) {
      const { offset, sbomLibs, total, totalFilteredSbomLibs } = response;

      setSbomOffset(offset);
      setSbomLibraries(sbomLibs, update);
      setSbomLibrariesTotal(total);
      setTotalSbomFilters(totalFilteredSbomLibs);
    }
  },
  {
    asyncState: SbomStore.loading,
    errorMessage: 'Failed to load sbom libraries',
  },
);

export const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  setSearchValue(e.target.value);
  onSearch();
};
export const onSearch = debounce(() => {
  loadSbomLibraries({ update: true });
  loadFilters();
}, 500);

export const selectSbom = (sbom: Nullable<SbomLibraryItem>) => {
  SbomStore.selectedSbom = sbom;
};
